export function isSandboxMicrositeHost(hostname = window.location.hostname) {
  return hostname.endsWith('.rg-sandbox.com')
}

export function normalizeCustomHost(customUrl) {
  if (!customUrl) return ''
  return String(customUrl).trim().replace(/^https?:\/\//i, '').replace(/\/$/, '')
}

/** Relative microsite asset path (/custom/...) or suffix passed to /custom prefix. */
export function resolveCustomAssetUrl(assetPath, customUrl) {
  if (!assetPath) return ''

  let path = String(assetPath).trim()
  if (!path.startsWith('/')) path = `/${path}`
  if (!path.startsWith('/custom')) path = `/custom${path}`

  if (!isSandboxMicrositeHost() || !customUrl) {
    return path
  }

  return `https://${normalizeCustomHost(customUrl)}${path}`
}

/** Rewrite relative /custom/ references inside CMS HTML for Sandbox hosts. */
export function rewriteSandboxCustomHtml(html, customUrl) {
  if (!html || !isSandboxMicrositeHost() || !customUrl) {
    return html
  }

  const host = normalizeCustomHost(customUrl)
  const prefix = `https://${host}/custom/`

  return String(html)
    .replace(/="\/custom\//g, `="${prefix}`)
    .replace(/='\/custom\//g, `='${prefix}`)
    .replace(/url\(\s*\/custom\//gi, `url(${prefix}`)
}
